// client/src/components/plataforma/siteInstitucional/ThemeSettings.js
import React, { useCallback } from 'react';

const ThemeSettings = React.memo(({ theme, onChange }) => {
    
    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        onChange({ ...theme, [name]: value });
    }, [theme, onChange]);

    return (
        <div className="form-section">
            <h3 className="form-section-title">🎨 Tema e Aparência</h3>
            <div className="form-grid-container grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                <div className="form-group">
                    <label>Cor Primária</label>
                    <div className="flex items-center gap-2">
                        <input 
                            type="color" 
                            name="primaryColor" 
                            value={theme.primaryColor || '#2563eb'} 
                            onChange={handleChange} 
                            className="w-8 h-8 rounded p-0 border-none cursor-pointer" 
                        />
                        <input 
                            type="text" 
                            name="primaryColor" 
                            value={theme.primaryColor || '#2563eb'} 
                            onChange={handleChange} 
                            className="form-input flex-1" 
                        />
                    </div>
                </div>
                
                <div className="form-group">
                    <label>Cor Secundária</label>
                    <div className="flex items-center gap-2">
                        <input 
                            type="color" 
                            name="secondaryColor" 
                            value={theme.secondaryColor || '#10b981'} 
                            onChange={handleChange} 
                            className="w-8 h-8 rounded p-0 border-none cursor-pointer" 
                        />
                        <input 
                            type="text" 
                            name="secondaryColor" 
                            value={theme.secondaryColor || '#10b981'} 
                            onChange={handleChange} 
                            className="form-input flex-1" 
                        />
                    </div>
                </div>
                
                <div className="form-group">
                    <label>Cor de Destaque</label>
                    <div className="flex items-center gap-2">
                        <input 
                            type="color" 
                            name="accentColor" 
                            value={theme.accentColor || '#f59e0b'} 
                            onChange={handleChange} 
                            className="w-8 h-8 rounded p-0 border-none cursor-pointer" 
                        />
                        <input 
                            type="text" 
                            name="accentColor" 
                            value={theme.accentColor || '#f59e0b'} 
                            onChange={handleChange} 
                            className="form-input flex-1" 
                        />
                    </div>
                </div>
                
                <div className="form-group">
                    <label>Cor de Fundo</label>
                    <div className="flex items-center gap-2">
                        <input 
                            type="color" 
                            name="backgroundColor" 
                            value={theme.backgroundColor || '#ffffff'} 
                            onChange={handleChange} 
                            className="w-8 h-8 rounded p-0 border-none cursor-pointer" 
                        />
                        <input 
                            type="text" 
                            name="backgroundColor" 
                            value={theme.backgroundColor || '#ffffff'} 
                            onChange={handleChange} 
                            className="form-input flex-1" 
                        />
                    </div>
                </div>
                
                <div className="form-group">
                    <label>Cor do Texto</label>
                    <div className="flex items-center gap-2">
                        <input 
                            type="color" 
                            name="textColor" 
                            value={theme.textColor || '#1f2937'} 
                            onChange={handleChange} 
                            className="w-8 h-8 rounded p-0 border-none cursor-pointer" 
                        />
                        <input 
                            type="text" 
                            name="textColor" 
                            value={theme.textColor || '#1f2937'} 
                            onChange={handleChange} 
                            className="form-input flex-1" 
                        />
                    </div>
                </div>
                
                <div className="form-group">
                    <label>Fonte</label>
                    <select 
                        name="fontFamily" 
                        value={theme.fontFamily || ''} 
                        onChange={handleChange} 
                        className="form-input"
                    >
                        <option value="Segoe UI, Tahoma, Geneva, Verdana, sans-serif">Segoe UI (Padrão)</option>
                        <option value="Arial, sans-serif">Arial</option>
                        <option value="Georgia, serif">Georgia</option>
                        <option value="'Helvetica Neue', Helvetica, Arial, sans-serif">Helvetica</option>
                        <option value="'Times New Roman', Times, serif">Times New Roman</option>
                        <option value="'Roboto', sans-serif">Roboto</option>
                        <option value="'Open Sans', sans-serif">Open Sans</option>
                    </select>
                </div>
                
                <div className="form-group">
                    <label>Raio da Borda</label>
                    <select 
                        name="borderRadius" 
                        value={theme.borderRadius || '8px'} 
                        onChange={handleChange} 
                        className="form-input"
                    >
                        <option value="0px">Sem borda (0px)</option>
                        <option value="4px">Pequeno (4px)</option>
                        <option value="8px">Médio (8px - Padrão)</option>
                        <option value="12px">Grande (12px)</option>
                        <option value="16px">Extra Grande (16px)</option>
                        <option value="24px">Circular (24px)</option>
                    </select>
                </div>
                
                <div className="form-group md:col-span-2">
                    <label>Sombra da Caixa</label>
                    <select 
                        name="boxShadow" 
                        value={theme.boxShadow || ''} 
                        onChange={handleChange} 
                        className="form-input"
                    >
                        <option value="none">Sem sombra</option>
                        <option value="0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)">Sombra suave</option>
                        <option value="0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)">Sombra média (Padrão)</option>
                        <option value="0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)">Sombra forte</option>
                        <option value="0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)">Sombra extra forte</option>
                    </select>
                </div>
            </div>
        </div>
    );
});

export default ThemeSettings;